// extracted by mini-css-extract-plugin
module.exports = {"DocumentUpload__priority":"DocumentUpload_DocumentUpload__priority__wVNOb","DocumentUpload__priorityLabel":"DocumentUpload_DocumentUpload__priorityLabel__1ovUE"};